import confetti from "canvas-confetti";

export function firstWinConfetti() {
  const end = Date.now() + 1800;
  const colors = ["#76B82A", "#D7A62A", "#F5F2E8"];
  (function frame() {
    confetti({
      particleCount: 5,
      angle: 60,
      spread: 55,
      startVelocity: 55,
      origin: { x: 0, y: 0.9 },
      colors,
    });
    confetti({
      particleCount: 5,
      angle: 120,
      spread: 55,
      startVelocity: 55,
      origin: { x: 1, y: 0.9 },
      colors,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
